import { html } from "../../helpers/stringHTML";

export const tooltipTexts = {
    dop_pokritie_stoleshnitsi: html`
        <div class="tooltip-container">
            <div>
                <b>Оцинкованное</b> покрытие используется для увеличения эксплуатационного ресурса стола.<br />
                Толщина оцинкованного покрытия - 1,2 мм.
            </div>
            <div>
                <b>Поликарбонатное</b> покрытие изготовлено из монолитного поликарбоната толщиной 3 мм и применяется в
                качестве рабочего покрытия для увеличения эксплуатационных характеристик стола.
            </div>

            <div>
                Преимущества:<br />
                • высокая ударопрочность (в 200 раз прочнее стекла), <br />
                • легкость в уходе при эксплуатации, <br />
                • температурная стойкость от -40 до +120°С <br />
            </div>

            <div>Не предназначено для работ с использованием технических растворителей и аммиака</div>
        </div>
    `,
    ogranichiteli_stoleshnitsi: html`
        <div class="tooltip-container">
            <div>
                Ограничители используются в качества ограждения рабочей поверхности стола и защиты от повреждений
                оборудования и техники. Высота ограничителя от уровня столешницы 38 мм
            </div>
        </div>
    `,
    uglovoi_stol: html`
        <div class="tooltip-container">
            <div>
                Стол приставной угловой предназначен для увеличения рабочего пространства и оптимального заполнения
                рабочей зоны.
            </div>
            <div>
                Устанавливается слева, справа от основного стола, высота столешницы регулируется в пределах от 650 мм до
                950 мм, глубина углового стола 500 мм.
            </div>
        </div>
    `,
    polka_dsp: html`
        <div class="tooltip-container">
            <div>
                Распределенная нагрузка на полку до 50 кг. Износостойкое покрытие из промышленного пластика обладает
                высокой стойкостью к термическим и механическим нагрузкам
            </div>
        </div>
    `,
    polka_metal: html`
        <div class="tooltip-container">
            <div>
                Полка металлическая устанавливается под столешницей на боковые опоры стола. По всей длине полки
                предусмотрен ограничитель (бортик) высотой 20 мм. Максимальная распределенная нагрузка на полку до 60
                кг. Материал полки – сталь, покрытая износостойкой порошковой краской
            </div>
        </div>
    `,
    bokovaya_pristavka: html`
        <div class="tooltip-container">
            <div>
                Используется для увеличения рабочего пространства и позволяет произвести установку на одном уровне со
                столешницей.
            </div>
            <div>
                Предусмотрена регулировка высоты, которая производится по боковому основанию стола. Возможна установка с
                обеих сторон стола
            </div>
        </div>
    `,
    kovrik_dlya_yashchika_tumbi: html`
        <div class="tooltip-container">
            <img src="./images/aksessuari/kovrik_dlya_yashchika_tumbi.jpg" alt="Коврик для ящика тумбы" />
            <div>Используется для защиты лакокрасочного покрытия ящика от механических повреждений.</div>
            <div>
                Материал коврика — полипропилен.<br />
                Верхний слой — текстурный, нижний слой глянцевый.<br />
                Цвет — черный.<br />
                Длина х Ширина — 500 х 390мм
            </div>
        </div>
    `,
    komplekt_peregorodok_verhnego_yashchika_kpv: html`
        <div class="tooltip-container">
            <img
                src="./images/aksessuari/komplekt_peregorodok_dlya_yashchika_tip-kpv.jpg"
                alt="Комплект перегородок верхнего ящика КПВ"
            />
            <div>
                Комплект перегородок КПВ для верхнего ящика, используется для упорядоченного хранения материалов.
                Конструкция продольных и поперечных перегородок, которые имеют прорези по всей длине перегородки с шагом
                30 мм. Максимальное количество ячеек при использовании полного комплекта перегородок — 35 шт
            </div>
            <div>
                Материал - металл.<br />
                Поперечные перегородки — 6 шт. Размер — 399 х 40 (Д х В) мм.<br />
                Продольные перегородки — 4 шт. Размер — 502 х 40 (Д х В) мм.
            </div>
        </div>
    `,
    komplekt_peregorodok_dlya_yashchika_tip_a: html`
        <div class="tooltip-container">
            <img
                src="./images/aksessuari/komplekt_peregorodok_dlya_yashchika_tip-a.jpg"
                alt="Комплект перегородок для ящика тип-А"
            />
            <div>
                Используется для упорядоченного хранения комплектующих. Конструкция поперечных перегородок, которые
                имеют прорези по всей длине с шагом 20 мм. Максимальное количество ячеек при использовании полного
                комплекта перегородок — 10 шт.
            </div>
            <div>
                Материал — металл.<br />
                Поперечные перегородки — 3 шт (шаг 20 мм).<br />
                Продольные перегородки 8 шт:<br />
                368 мм — 4 шт<br />
                115 мм — 4 шт
            </div>
        </div>
    `,
    komplekt_peregorodok_dlya_yashchika_tip_b: html`
        <div class="tooltip-container">
            <img
                src="./images/aksessuari/komplekt_peregorodok_dlya_yashchika_tip-b.jpg"
                alt="Комплект перегородок для ящика тип-Б"
            />
            <div>
                Используется для упорядоченного хранения комплектующих. Конструкция поперечных перегородок, которые
                имеют прорези по всей длине с шагом 20 мм. Максимальное количество ячеек при использовании полного
                комплекта перегородок — 10 шт.
            </div>
            <div>
                Материал — металл.<br />
                Поперечные перегородки — 3 шт. (шаг 20 мм).<br />
                Продольные перегородки длиной 242 мм. — 8 шт.
            </div>
        </div>
    `,
    komplekt_peregorodok_dlya_yashchika_tip_v: html`
        <div class="tooltip-container">
            <img
                src="./images/aksessuari/komplekt_peregorodok_dlya_yashchika_tip-v.jpg"
                alt="Комплект перегородок для ящика тип-В"
            />
            <div>
                Используется для упорядоченного хранения комплектующих. Конструкция поперечных перегородок, которые
                имеют прорези по всей длине с шагом 20 мм. Максимальное количество ячеек при использовании полного
                комплекта перегородок — 13 шт.
            </div>
            <div>
                Материал — металл.<br />
                Поперечные перегородки — 3 шт. (шаг 20 мм).<br />
                Продольные перегородки 10 шт.:<br />
                242 мм. — 4 шт.<br />
                115 мм. — 6 шт.
            </div>
        </div>
    `,
    podstavka_pod_sistemnii_blok: html`
        <div class="tooltip-container">
            <div>
                Предназначена для удобного размещения системного блока персонального компьютера под столешницей.
                Крепится в удобном месте под столешницей.
            </div>
            <div>
                Подвесная:<br />
                • Габаритные размеры (Ш х В х Г) 265×460×460 мм.<br />
                • Пределы регулировки. По ширине: от 200 до 300 мм. По высоте от 430 до 530 мм.<br />
                • Высота и ширина подставки регулируется с шагом 50 мм.<br />
                • Максимальная нагрузка - 30 кг.<br />
            </div>
            <div>
                Подкатная:<br />
                • Габаритные размеры (Ш х В х Г) 265×460×460 мм.<br />
                • Четыре колесные опоры из них две с механизмом фиксации<br />
                • Регулировка по ширине: от 200 до 300 мм.<br />
                • Максимальная нагрузка - 30 кг.<br />
            </div>
        </div>
    `,
    polka_dlya_kantselyarskikh_prinadlezhnostei: html`
        <div class="tooltip-container">
            <div>
                Предусматривает расположение в рабочей зоне стола и служит вспомогательным элементом, для размещения
                мелких канцелярских принадлежностей, в пределах легкой досягаемости.
            </div>
            <div>
                Полка закрепляется под лицевой частью столешницы в любом удобном для работы месте, на лицевой части
                полки, имеется борт высотой 10 мм. Материал - сталь
            </div>
        </div>
    `,
    polka_vydvizhnaya_pod_orgtehniku: html`
        <div class="tooltip-container">
            <div>
                Выдвижной лоток обеспечивает легкую и удобную замену расходных материалов в принтерах и иной оргтехнике.
                Крепление производится под столешницей.
            </div>
            <div>
                • Габариты: Ширина: 500 мм, Глубина: 510 мм, Высота: 515 мм<br />
                • Габариты выдвижного лотка: Ширина: 430 мм, Глубина: 500 мм<br />
                • Максимальная нагрузка на полку составляет - 30 кг
            </div>
        </div>
    `,
    lotok_dlya_provodov: html`
        <div class="tooltip-container">
            <div>
                Предназначен для компактного размещения, укладки и защиты от различных повреждений кабелей периферийных
                устройств, системных блоков, мониторов, блоков розеток. В лотке имеются технологические отверстия для
                удобного вывода и подвода кабелей.
            </div>
            <div>
                Металлический лоток, размещающийся за рабочим местом, по всей его длине, имеет плавную регулировку
                высоты, фиксация лотка производиться на задних вертикальных стойках.
            </div>
        </div>
    `,
    podstavka_pod_nogi: html`
        <div class="tooltip-container">
            <div>
                Используется для снятия нагрузки с ног и поясничного отдела при длительной сидячей работе. Снижает
                усталость и стимулирует кровообращение в ногах. Имеет несколько регулировок угла наклона с фиксацией
                положения.
            </div>
            <div>
                На верхнюю поверхность подставки под ноги установлено износостойкое резиновое покрытие с антискользящими
                свойствами
            </div>
        </div>
    `,
    komplekt_stoek: html`
        <div class="tooltip-container">
            <img src="./images/komplekt_stoek.png" alt="Комплект стоек" />
            <div class="text-center">Комплект стоек</div>
        </div>
    `,
    polka_pribornaya_dsp: html`
        <div class="tooltip-container">
            <div>
                Высота установки над столешницей регулируется от 100 до 900 мм. Распределенная нагрузка на полку до 50
                кг. Износостойкое покрытие из промышленного пластика обладает высокой стойкостью к термическим и
                механическим нагрузкам
            </div>
        </div>
    `,
    polka_pribornaya_naklonnaya_metall: html`
        <div class="tooltip-container">
            <div>
                Полка наклонная металлическая – универсальное решение для адаптации к разным задачам и требованиям.
                Имеет плавную регулировку угла наклона от горизонтального положения 90° до 115°. Встроенные передний и
                задний края, которые предотвращают скатывание расположенных на ней предметов. Максимальная нагрузка на
                полку — до 75 кг
            </div>
        </div>
    `,
    osveshchenie_verkhnee: html`
        <div class="tooltip-container">
            <div>
                Тип “Прямой”:<br />
                Фиксируется на задние стойки на кронштейнах Г-образной формы, регулируется по высоте от уровня
                столешницы от 400 до 1400 мм, с помощью держателей регулируется направления потока света.
            </div>
            <div>
                Тип “Наклонный”:<br />
                Фиксируется на КС на кронштейнах , регулируется по высоте от уровня столешницы от 400 до 1400 мм, В
                комплекте: кронштейн для крепления освещения, светильник LED, 32-53 Вт., 4400-6200 Лм., 5000 К., IP66,
                вилка, провод 3 м., материал рассеивателя - опаловый акрил.
            </div>
            <div>
                • Потребляемая мощность 32-53 Вт<br />
                • световой поток 4400-6200 Лм<br />
                • 5000 K<br />
                • IP66<br />
                • провод 3 м<br />
                • материал рассеивателя – опаловый акрил
            </div>
        </div>
    `,
    osveshchenie_pod_pribornuyu_polku: html`
        <div class="tooltip-container">
            <div>
                Устанавливается под полку для приборов и оборудования. Предназначен для равномерного освещения
                пространства рабочей поверхности стола.
            </div>
            <div>
                • Регулировка угла наклона – 170°<br />
                • Цветовая температура 4700-5300 Κ<br />
                • Сетевой провод – 3 м<br />
            </div>
        </div>
    `,
    osveshchenie_bokovoe: html`
        <div class="tooltip-container">
            <div>
                Для боковой подсветки рабочей поверхности стола. Возможна установка с правой и с левой стороны стола.
            </div>
            <div>
                • Цветовая температура 4700-5300 Κ<br />
                • Сетевой провод – 3 м<br />
            </div>
        </div>
    `,
    perfopanel: html`
        <div class="tooltip-container">
            <div>
                Предназначена для крепления и подвеса инструмента с помощью креплений и крючков для инструментов,
                обеспечивая эффективное хранение и организацию инструментов и принадлежностей за рабочим местом
            </div>
        </div>
    `,
    panel_elektromontazhnaya: html`
        <div class="tooltip-container">
            <div>
                Алюминиевый короб с электрическими розетками, с заземляющим контактом. В базовом варианте установлено 4
                розетки, шнур 3 метра, кнопка с индикацией питания. Максимальный ток нагрузки 16 A.
            </div>
            <div>
                В качестве дополнительного оснащения имеется возможность дооснащения дополнительным количеством розеток,
                УЗО, автоматом безопасности 10А и 16А
            </div>
        </div>
    `,
    lotok_metallicheskii: html`
        <div class="tooltip-container">
            <div>
                Предназначен для размещения вспомогательных материалов, аксессуаров и принадлежностей в рабочей зоне, по
                всей длине рабочего стола.
            </div>
            <div>
                Имеет плавную регулировку, фиксация лотка производиться на задних вертикальных стойках, на любой удобной
                высоте, предполагая нахождение всех необходимых вспомогательных материалов и мелких принадлежностей в
                пределах легкой досягаемости
            </div>
        </div>
    `,
    planka_dlya_lotkov: html`
        <div class="tooltip-container">
            <div>
                Предназначена для расположения и крепления промышленных и антистатических лотков, компонентов и
                комплектующих различных размеров. Крепится на задние стойки стола и регулируется по высоте.
            </div>
            <div>Лотки заказываются отдельно</div>
        </div>
    `,
    derzhatel_monitora: html`
        <div class="tooltip-container">
            <div>
                Позволяет расположить монитор на нужном расстоянии от места крепления и под необходимым углом наклона,
                что создаст комфортные условия для работы.
            </div>
            <div>
                • Максимальная нагрузка на кронштейн – 20 кг<br />
                • Расстояние от места крепления до площадки монитора 1 рычаг – 225 мм, 2 рычага – 335 мм<br />
                • Диагональ монитора – 17"-37"<br />
                • Стандарт VESA – 75x75, 100x100, 200x100, 200х200 мм<br />
            </div>
        </div>
    `,
    elektropanel: html`
        <div class="tooltip-container">
            <div>
                Предназначена для распределения электропитания между потребителями и защиты электронной техники и
                активного оборудования.
            </div>
            <div>
                • Шнур 2 метра<br />
                • Переключатель с индикацией включения питания<br />
                • Автоматический предохранитель<br />
                • Максимальный ток нагрузки 16 А<br />
                • Колодки розеток изготовлены из высококачественного негорючего пластика<br />
                • Может быть закреплен на перфопанели, планке для лотков, на задних стойках или использоваться
                независимо от стола как промышленный сетевой фильтр<br />
            </div>
        </div>
    `,
    kronshtein_dlya_printera: html`
        <div class="tooltip-container">
            <div>
                Используется для размещения различного рода портативной оргтехники, периферийных устройств и
                приспособлений.
            </div>
            <div>
                • Металлическая площадка имеет габарит 320x320 мм<br />
                • Снабжена удобной ручкой для вращения и пазами для укладки электропроводов устройств<br />
                • Максимальная нагрузка на кронштейн - до 20 кг<br />
            </div>
            <div>
                Конструкция кронштейна позволяет расположить подставку на нужном расстоянии от места крепления и под
                необходимым углом разворота, что создает комфортные условия для использования размещенных на ней
                устройств
            </div>
        </div>
    `,
    podstavka_dlya_chertezhei: html`
        <div class="tooltip-container">
            <div>
                • 4 магнита для фиксации чертежно-технической документации<br />
                • Размер рабочей поверхности 310х430 мм<br />
            </div>
        </div>
    `,
    instrumentalnaya_planka: html`
        <div class="tooltip-container">
            <div>
                Предназначена для подвеса инструментов, оборудования, схем, чертежей при помощи карабина или возвратного
                механизма (заказывается отдельно)
            </div>
        </div>
    `,
    derzhatel_ruchnogo_instrumenta: html`
        <div class="tooltip-container">
            <div>
                Держатель ручного инструмента (ДРУ) предназначен для фиксации и удерживания инструмента, который должен
                быть всегда под рукой во время рабочего процесса. Держатель имеет подпружиненную катушку с намотанным на
                нее поддерживающим тросом, натяжение которого регулируется в зависимости от веса фиксируемого
                инструмента. Максимальный вес инструмента не должен превышать 1,5 кг
            </div>
        </div>
    `,
    kryuchok_na_perfopanel__1: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-1</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__1.png" alt="Держатель отверток" />
            <div class="text-center">Держатель отверток</div>
        </div>
    `,
    kryuchok_na_perfopanel__2: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-2</div>
            <img
                src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__2.png"
                alt="Держатель мелких инструментов"
            />
            <div class="text-center">Держатель мелких инструментов</div>
        </div>
    `,
    kryuchok_na_perfopanel__3: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-3</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__3.png" alt="Держатель инструмента" />
            <div class="text-center">Держатель инструмента</div>
        </div>
    `,
    kryuchok_na_perfopanel__4: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-4</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__4.png" alt="Держатель ключей" />
            <div class="text-center">Держатель ключей</div>
        </div>
    `,
    kryuchok_na_perfopanel__5: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-5</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__5.png" alt="Держатель молотка" />
            <div class="text-center">Держатель молотка</div>
        </div>
    `,
    kryuchok_na_perfopanel__6: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-6</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__6.png" alt="Лоток мелких элементов" />
            <div class="text-center">Лоток мелких элементов</div>
        </div>
    `,
    kryuchok_na_perfopanel__7: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-7</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__7.png" alt="Держатель папок" />
            <div class="text-center">Держатель папок</div>
        </div>
    `,
    kryuchok_na_perfopanel__8: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-8</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__8.png" alt="Лоток для мелочей" />
            <div class="text-center">Лоток для мелочей</div>
        </div>
    `,
    kryuchok_na_perfopanel__9: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-9</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__9.png" alt="Держатель отверток" />
            <div class="text-center">Держатель отверток</div>
        </div>
    `,
    kryuchok_na_perfopanel__10: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-10</div>
            <img
                src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__10.png"
                alt="Держатель мелких инструментов"
            />
            <div class="text-center">Держатель мелких инструментов</div>
        </div>
    `,
    kryuchok_na_perfopanel__11: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-11</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__11.png" alt="Держатель скотча" />
            <div class="text-center">Держатель скотча</div>
        </div>
    `,
    kryuchok_na_perfopanel__12: html`
        <div class="tooltip-container">
            <div class="hook_title">КР-12</div>
            <img src="./images/kryuchki_na_perfopanel/kryuchok_na_perfopanel__12.png" alt="Держатель папок" />
            <div class="text-center">Держатель папок</div>
        </div>
    `,
    podlokotniki: html`
        <div class="tooltip-container">
            <div>
                Антистатические полиуретановые термостойкие с возможностью регулировки по высоте.<br />
                Комплект поставки: 2 подлокотника и крепления
            </div>
        </div>
    `,
    koltso_opornoe: html`
        <div class="tooltip-container">
            <div>Регулируется по высоте, обеспечивая комфортное размещение. Диаметр 400 мм.</div>
        </div>
    `,
    gazlift: html`
        <div class="tooltip-container">
            <div>Высокий газлифт: Регулировка сидения по высоте от 500 до 750 мм. Хромированное покрытие.</div>
        </div>
    `,
    opora: html`
        <div class="tooltip-container">
            <div>Глайдеры: Набор из 5 антистатических стационарных опор. Диаметр основания 50 мм.</div>
        </div>
    `,
};
